import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("rect", {
  x: 2,
  y: 2,
  width: 20,
  height: 20,
  rx: 4,
  fill: "#757575"
});

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  x: 6,
  y: 11,
  width: 12,
  height: 2,
  rx: 1,
  fill: "#fff"
});

var SvgCheckboxIndeterminate = function SvgCheckboxIndeterminate(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgCheckboxIndeterminate;